// src/components/InboxContent.tsx
import React, { useMemo } from "react";
import { useNotificationOutlets } from "../hooks/internal/useNotificationOutlets.js";
import { Mounter } from "./Mounter.js";
import { jsx } from "react/jsx-runtime";
var InboxContent = React.memo((props) => {
  const { onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, initialPage, hideNav } = props;
  const outlets = useNotificationOutlets(props);
  const mountProps = useMemo(
    () => ({ ...outlets, onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, initialPage, hideNav }),
    [outlets, onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, initialPage, hideNav]
  );
  return /* @__PURE__ */ jsx(Mounter, { name: "InboxContent", props: mountProps });
});
InboxContent.displayName = "InboxContent";
export {
  InboxContent
};
//# sourceMappingURL=InboxContent.js.map